export const getEndpoint = (msName: string) => `${process.env.API_URL}${msName}/`;

export const getMicroserviceEndpoint = (microServiceName: string, isLocalhostMs?: boolean) => {
    const endpoint = isLocalhostMs ? process.env.LOCALHOST_API_URL : process.env.API_URL;

    return `${endpoint}${microServiceName}`;
};
